import type { Context } from '@opentelemetry/api';
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';
import { API_BASE } from '@/env';

const apiClient = axios.create({
  baseURL: API_BASE,
});

export async function apiGet<T>(
  url: string,
  context: Context,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<T>> {
  return await apiClient.get<T>(url, config);
}
